<div class="sub-header">
    <div class="title">{{ 'SHARED.ROUTE.ACQUIRE.WIZARD.RESUM.TITLE' | translate}}</div>
    <div class="help-text">{{ 'SHARED.ROUTE.ACQUIRE.WIZARD.RESUM.HELP' | translate}}</div>

</div>
<shared-partner-acquire-route-item [partner]="wizard.selectedPartner"
    class="item partnerItem monochrome reduced noborder linebottom">
</shared-partner-acquire-route-item>

<div class="list">
    <shared-route-acquire-route-item *ngFor="let item of getRoutes()" [route]="item"
        class="item partnerItem monochrome reduced nohover">
    </shared-route-acquire-route-item>
</div>